import classNames from 'classnames'
import css from '../AuthorProfile.styles.scss'

const Affiliations = ({ author }) => {
  if (author.affiliations && author.affiliations.length > 0) {
    return (
      <div id="affiliations" className={classNames(css.authorProfileSection)}>
        <h2>Affiliations</h2>
        <ul>
          {author.affiliations.map((affiliation, i) => (
            <li key={i}>
              <strong>{affiliation.issuingOrganization}</strong> -{' '}
              {affiliation.name}
            </li>
          ))}
        </ul>
      </div>
    )
  } else {
    return null
  }
}

export default Affiliations
